<template>
  <div class="rounded overflow-hidden h-full">
    <div class="board-canvas relative flex-grow h-full">
      <div
        :class="[
          'board',
          'absolute',
          'inset-0',
          'select-none',
          'whitespace-nowrap',
          'space-x-1',
          'pb-2',
          'overflow-x-auto',
          'overflow-y-hidden',
        ]"
      >
        <template v-for="list in lists">
          <slot :list="list" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VKanbanBoard',

  props: {
    lists: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
